<svg [ngClass]="class" viewBox="0 0 19 19"  xmlns="http://www.w3.org/2000/svg">
  <path d="M8.42857 14.8571C11.979 14.8571 14.8571 11.979 14.8571 8.42857C14.8571 4.87817 11.979 2 8.42857 2C4.87817 2 2 4.87817 2 8.42857C2 11.979 4.87817 14.8571 8.42857 14.8571Z"
        [style.fill]="fillColor"
        stroke="#B79086" stroke-width="2.14286" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M17.0004 17.0002L13.7861 13.7859" stroke="#B79086" stroke-width="2.14286" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
